import { type UsageView, usageViewsBodySchema } from "@crux/contracts";
import { problem } from "./errors.js";

/**
 * Records screens that were on screen (`lib/usage`). `keepalive`, so a view
 * ended by closing the tab still arrives after the page is gone. A Rust-only
 * route, parsed against the shared contract before it leaves.
 */
export async function sendViews(
  workspaceId: string,
  views: readonly UsageView[],
): Promise<void> {
  const body = usageViewsBodySchema.parse({ views });
  const response = await fetch(
    `${window.location.origin}/api/workspaces/${encodeURIComponent(workspaceId)}/usage/views`,
    {
      method: "POST",
      credentials: "same-origin",
      keepalive: true,
      headers: { "content-type": "application/json" },
      body: JSON.stringify(body),
    },
  );
  if (!response.ok)
    throw new Error(problem(response.status, "record which screen was open"));
}
